import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultSelectedSubscription = () => {
  return {
    ageLimit: null,
    distanceLimit: null,
    weeklyTicketLimit: null,
    validDayCount: null,
    ticketLimitPerDayPerDirection: null,
    freeAdditionalServiceIds: [],
    discountRates: [],
    salesChannelIds: [],
    toStationId: null,
    fromStationId: null,
    allowIntermediateStations: false,
    trainType: [],
    saleStartDate: null,
    saleEndDate: null,
    packageTotalSalePriceNewStartDate: null,
    cabinClassId: null,
    validDaysOfWeek: [],
    trainTypes: [],
    cabinClasses: [],
    type: "DAY_COUNT",
    enabled: true,
    purchaseSalesChannelIds: [],
    multiStations: false,
    multiStationIds: [],
  };
};

export default {
  state: () => ({
    selectedSubscription: getDefaultSelectedSubscription(),
  }),

  mutations: {
    setSelectedSubscription(state, selectedSubscription) {
      Vue.set(state, "selectedSubscription", selectedSubscription);
    },
    setDefaultSelectedSubscription(state) {
      Vue.set(state, "selectedSubscription", getDefaultSelectedSubscription());
    },
  },

  actions: {
    //TODO: load, update, create
    loadSubscriptions: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/subscriptions/entity", {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadSubscription: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/subscriptions/entity/" + request.id, {}).then((response) => {
        context.commit("setSelectedSubscription", response.data);
        return response.data;
      });
    },
    createSubscriptionPackage: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/subscriptions/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadSelectedSubscriptionHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/subscriptions/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    sendToApprovalSubscription: (context, mainUnit) => {
      return axios.get(context.getters.getMcServiceUrl + "/subscriptions/sendToApproval/" + mainUnit.intentId).then((response) => {
        if (mainUnit.intents[0].type === "CREATE_SUBSCRIPTION") {
          mainUnit.intents[0].status = "WAITING_APPROVAL";
        } else if (mainUnit.intents[0].type === "UPDATE_SUBSCRIPTION") {
          mainUnit.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
    publishSubscription: (context, subscription) => {
      return axios.get(context.getters.getMcServiceUrl + "/subscriptions/publish/" + subscription.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectSubscription: (context, subscription) => {
      return axios.get(context.getters.getMcServiceUrl + "/subscriptions/reject/" + subscription.intentId).then((response) => {
        if (subscription.intents[0].type === "DELETE_SUBSCRIPTION") {
          subscription.intents = null;
          subscription.intentId = 0;
        } else if (subscription.intents[0].type === "CREATE_SUBSCRIPTION") {
          subscription.intents[0].status = "DRAFT";
        } else if (subscription.intents[0].type === "UPDATE_SUBSCRIPTION") {
          subscription.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },
    recallSubscription: (context, mainUnit) => {
      return axios.get(context.getters.getMcServiceUrl + "/subscriptions/recall/" + mainUnit.intentId).then((response) => {
        helper.recallOrRejectEntity(mainUnit, "subscription");
        return response.data;
      });
    },
    cancelSubscription: (context, mainUnit) => {
      return axios.get(context.getters.getMcServiceUrl + "/subscriptions/cancel/" + mainUnit.intentId).then((response) => {
        return response.data;
      });
    },
    deleteSubscription: (context, item) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/subscriptions/entity/" + item.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          item.intents = intents;
          item.intentId = response.data.id;
          return item;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftSubscription: (context, item) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/subscriptions/draft/" + item.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    //
    loadSubscriptionPurchasesUserId: (context, request) => {
      return axios.get(context.getters.getCrsServiceUrl + "/subscription-purchases/find-by-user-id/" + request, {}).then((response) => {
        return response.data;
      });
    },
    loadSearchSubscriptions: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/subscriptions/search", request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadSubscriptionPurchasesCalculate: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/subscription-purchases/calculate", request, {})
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    createSubscriptionPurchases: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/subscription-purchases", request, { headers: { "sales-channel-id": 3 } })
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    cancelCalculateSubscription: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/subscription-purchases/cancel-calculate", request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    cancelSubscriptionPackage: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/subscription-purchases/cancel", request, { headers: { "sales-channel-id": 3 } })
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    // discount
    loadDiscountPackagePurchasesUserId: (context, request) => {
      return axios.get(context.getters.getCrsServiceUrl + "/discount-package-purchases/find-by-user-id/" + request).then((response) => {
        return response.data;
      });
    },
    loadSearchDiscountPackages: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/discount-packages/search", request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    createDiscountPackagePurchases: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/discount-package-purchases", request, { headers: { "sales-channel-id": 3 } })
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    cancelDiscountPackagePurchases: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/discount-package-purchases/cancel", request, { headers: { "sales-channel-id": 3 } })
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    updateDiscountPackagePurchases: (context, request) => {
      return axios
        .put(context.getters.getCrsServiceUrl + "/discount-package-purchases", request, { headers: { "sales-channel-id": 3 } })
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadSelectedSubscriptionPurchasesHistory: (context, request) => {
      return axios
        .get(context.getters.getCrsServiceUrl + "/subscription-purchases/" + request.id + "/history", { headers: { "sales-channel-id": 3 } })
        .then((response) => {
          return response.data;
        });
    },
    loadSubscriptionsByUserId: (context, request) => {
      return axios
        .get(context.getters.getCrsServiceUrl + "/purchase-histories/subscriptions/" + request.userId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadPackagePurchasesBarcode: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/package-purchases/barcode", request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
  },
  getters: {
    getSelectedSubscription: (state) => {
      return state.selectedSubscription;
    },
  },
};
